import { localStore } from '@/utils/store'

export const isDev = process.env.NODE_ENV
export const baseUrl = process.env.VUE_APP_SERVER_URL
export const lang = localStore.get('lang') || 'cn'
